export default "__VITE_ASSET__7cb6c7db__"